import { t } from '@lingui/core/macro';
import { Chip, Tooltip, Typography, useToast } from '@pocketlaw/tetris';
export function IdChip(props) {
    const { id, type, size = 'medium' } = props;
    const { addToast } = useToast();
    const labelSizeMap = {
        small: 'tiny',
        medium: 'small',
    };
    const labelMap = {
        contract: t({ comment: 'Contract ID chip - Label', message: 'CID' }),
        project: t({ comment: 'Project ID chip - Label', message: 'PID' }),
    };
    const tooltipMap = {
        contract: t({ comment: 'Contract ID chip - Tooltip', message: 'Copy contract ID to clipboard' }),
        project: t({ comment: 'Project ID chip - Tooltip', message: 'Copy project ID to clipboard' }),
    };
    const label = labelMap[type];
    const labelSize = labelSizeMap[size];
    const tooltip = tooltipMap[type];
    const copyToClipboard = () => {
        navigator.clipboard.writeText(id).then(() => {
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Copied ID to clipboard',
                    comment: 'Copy ID to clipboard toast success message',
                }),
            });
        });
    };
    return (<Tooltip side="top" delay={500} title={tooltip}>
      <Chip size={size} icon={<Typography $color="swatches.gray.700" $fontWeight="semibold" $fontSize={labelSize}>
            {label}
          </Typography>} secondary={id} appearance="secondary" onClick={copyToClipboard}/>
    </Tooltip>);
}
